import {BaseDTO} from "../../../../../core/dto/BaseDTO";
import {OrganisationOwnerDTO} from "../../../../DTO/Organisation/OrganisationOwnerDTO";
import {EnumOrganisationType, OrganisationDTO} from "../../../../DTO/Organisation/OrganisationDTO";
import {PromptType} from "./prompt-type.enum";
import {PromptPriority} from "./prompt-priority.enum";
import {PromptVersionDTO} from "./prompt-version.dto";


export class PromptsDTO extends  BaseDTO{
  id:number;
  promptName:string;
  promptText:String;
  description:string;
  type:PromptType;
  priority:PromptPriority;
  tags:string[] = [];
  organisation:OrganisationDTO;
  versions:PromptVersionDTO;

  constructor() {
    super();
  }
  override bindData(obj: any): void {
    if (obj == null) {
      return;
    }
    super.bindData(obj);
    this.id = obj.id;
    this.promptName = obj.promptName;
    this.promptText = obj.promptText;
    this.description = obj.description;
    this.priority=obj.priority;
    this.type = obj.type as PromptType;
    this.tags = obj.tags || [];

    if (obj.organisation) {
      this.organisation = new OrganisationDTO();
      this.organisation.bindData(obj.organisation);
    }

    if (obj.versions) {
      this.versions = new PromptVersionDTO();
      this.versions.bindData(obj.versions);
    }

  }

}
